const Cookies = require('js-cookie');

module.exports = {
  get(cookieName) {
    return Cookies.get(cookieName);
  },

  set(cookieName, value) {
    return Cookies.set(cookieName, value);
  },
};



// WEBPACK FOOTER //
// ./javascripts/components/reverb_cookie.js